// extracted by mini-css-extract-plugin
export var heroImage = "_mk-1";
export var modal = "_mk-0";